import { memo } from 'react';

import { Tooltip } from 'shared/Houston';

import { Container, InfoSolidStyled, Label, TextArea } from './styles';

interface IProps {
  name: string;
  contentId: number;
  onBlur: (contentId: number, description: string) => void;
  value?: string;
}

const DescriptionBumpItem: React.FC<IProps> = ({ name, onBlur, contentId, value }) => {
  return (
    <Container>
      <Label htmlFor={name}>
        Digite um texto adicional para este produto de order bump (opcional)
        <Tooltip title='Textos adicionais serão exibidos apenas no Checkout Elements'>
          <InfoSolidStyled />
        </Tooltip>
      </Label>
      <TextArea name={name} onBlur={e => onBlur(contentId, e.target.value)} defaultValue={value} maxLength={240} />
    </Container>
  );
};

export default memo(DescriptionBumpItem);
